import { render, staticRenderFns } from "./tempPengiraanBGE.vue?vue&type=template&id=6fee4449&scoped=true&"
import script from "./tempPengiraanBGE.vue?vue&type=script&lang=js&"
export * from "./tempPengiraanBGE.vue?vue&type=script&lang=js&"
import style0 from "./tempPengiraanBGE.vue?vue&type=style&index=0&id=6fee4449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fee4449",
  null
  
)

export default component.exports